import { Suspense, lazy } from "react"

import { Loader } from "@/molecules/Loader"

import type { ComingSoonPageProps } from "./ComingSoonPage.types"

const DefaultPage = lazy(() => import("./components/pages/DefaultPage"))

export const ComingSoonPage = ({
  classes,
  isLoading,
  ...props
}: ComingSoonPageProps) => {
  const className = classes?.fallback

  return (
    <Suspense fallback={<Loader className={className} />}>
      {isLoading && <Loader className={className} />}
      {!isLoading && <DefaultPage {...props} />}
    </Suspense>
  )
}
